import { render, staticRenderFns } from "./SmsTempSendView.vue?vue&type=template&id=2031cb28&scoped=true"
import script from "./SmsTempSendView.vue?vue&type=script&lang=js"
export * from "./SmsTempSendView.vue?vue&type=script&lang=js"
import style0 from "./SmsTempSendView.vue?vue&type=style&index=0&id=2031cb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031cb28",
  null
  
)

export default component.exports